module.exports = __webpack_public_path__ + "static/img/updateIcon.e8b4154a.png";